import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisRequest = ApiDefinition['/user-notes']['POST'];
type Input = ThisRequest['body'];
type Output = ThisRequest['response'];

const addUserNotes = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/user-notes', payload);
  return response.data;
};

export default addUserNotes;
